import OfferListSection from '../modules/offer-list';

const sections = document.querySelectorAll('[data-offer-list]');
const initOfferListSections = sections => {
    if (sections) {
        sections.forEach(section => new OfferListSection(section));
    }
};

initOfferListSections(sections);
